module.exports = __webpack_public_path__ + "img/1.0029e09d.jpg";